export default __webpack_public_path__ + "88389fc175cfac1d5b75076be1a06715.svg";